import React, { Fragment, useContext } from "react";
import { ListBuilder, PageLoader } from "@redriver/cinnamon";
import { getBookingDocuments } from "./actions";
import BookingRefContext from "./BookingRefContext";
import DocumentTile from "./DocumentTile";
import UploadRepFile from "./UploadRepFile";
import { ContentPanel } from "components/containers";

const DocumentsPanel = ({ bookingId }) => {
  const bookingRef = useContext(BookingRefContext);
  return (
    <ContentPanel title="Documents">
      <ListBuilder
        loadAction={getBookingDocuments}
        loadParams={bookingId}
        loadTransform={(data) =>
          data.map((x, i) => ({ ...x, id: `${x.name}~${i}` }))
        }
        renderList={(data, state, events) => {
          if (state.loading) {
            return <PageLoader />;
          }

          return (
            <Fragment>
              <div style={{ marginBottom: "1em" }}>
                <UploadRepFile
                  bookingId={bookingId}
                  onRefresh={events.onRefresh}
                />
              </div>
              <div className="booking-docs-grid">
                {!Array.isArray(data) || data.length == 0 ? (
                  <p>No documents found</p>
                ) : (
                  data.map((x) => (
                    <DocumentTile
                      document={x}
                      bookingRef={bookingRef}
                      key={x.id}
                    />
                  ))
                )}
              </div>
            </Fragment>
          );
        }}
      />
    </ContentPanel>
  );
};

export default DocumentsPanel;
